module.exports = __webpack_public_path__ + "static/media/content-check.40580343.gif";